import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorState, AddErrorNotificationPayload } from "./types";

export const errors = createSlice({
  name: "errors",
  initialState: {
    error: undefined,
    lastId: 0,
  } as ErrorState,
  reducers: {
    setErrorNotification: (
      state,
      { payload }: PayloadAction<AddErrorNotificationPayload>
    ) => {
      state.error = { ...payload, id: ++state.lastId };
    },
    removeErrorNotification: (state) => {
      state.error = undefined;
    },
  },
});
export const { setErrorNotification, removeErrorNotification } = errors.actions;

export default errors.reducer;
